"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsErrorPage = void 0;
const React = __importStar(require("react"));
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const ProjectsErrorPage = (props) => {
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const onClickTryAgain = async () => {
        projectsContext.fetchAllProjects();
    };
    const subTitle = React.createElement(React.Fragment, null,
        "Projects data cannot be loaded.",
        React.createElement("br", null),
        "Error: ",
        props.error.message,
        React.createElement("br", null),
        "Please try again.");
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(antd_1.Result, { title: "Oops, something went wrong", subTitle: subTitle, extra: React.createElement(antd_1.Button, { type: "primary", size: "large", onClick: onClickTryAgain, disabled: projectsContext.projectsState.inProgress, loading: projectsContext.projectsState.inProgress }, "Try Again") }))));
};
exports.ProjectsErrorPage = ProjectsErrorPage;
